"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderCard = void 0;
const react_1 = require("react");
const fetchData_1 = require("../../utils/fetchData");
const CustomLineChart_1 = __importDefault(require("../../components/charts/CustomLineChart"));
const react_2 = __importDefault(require("react"));
const SimpleTable_1 = __importDefault(require("@/components/list/SimpleTable"));
const format_1 = require("@/utils/format");
const slider_1 = __importDefault(require("@/components/slider/slider"));
const Section_1 = __importDefault(require("@/components/layout/Section"));
const material_1 = require("@mui/material");
const styled_components_1 = __importStar(require("styled-components"));
const TotalSupplyCards_1 = __importDefault(require("./sections/TotalSupplyCards"));
const BurnedTokens_1 = __importDefault(require("./sections/BurnedTokens"));
const FOC_1 = __importDefault(require("./sections/FOC"));
const Overview_1 = require("../governance/sections/Overview");
const HelmetTitle_1 = __importDefault(require("@/components/interactions/HelmetTitle"));
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const themes_1 = require("@/theme/themes");
const react_router_dom_1 = require("react-router-dom");
// import { Text } from '../governance/governance';
function OgyDashboard() {
    const [tokenSupply, setTokenSupply] = (0, react_1.useState)();
    const [tokenSupplyPayload, setTokenSupplyPayload] = (0, react_1.useState)();
    const [burnedTokens, setBurnedTokens] = (0, react_1.useState)();
    const [balanceList, setBalanceList] = (0, react_1.useState)();
    const [isLoading, setIsPageLoading] = (0, react_1.useState)(true);
    const [supplyMetrics, setSupplyMetrics] = (0, react_1.useState)();
    const [foundationHolding, setFoundationHolding] = (0, react_1.useState)();
    const [tokenDistribution, setTokenDistribution] = (0, react_1.useState)();
    const isDarktheme = (0, react_router_dom_1.useOutletContext)();
    const getData = async () => {
        try {
            const result = await Promise.all([
                (0, fetchData_1.getBalanceListByPage)(1, 10),
                (0, fetchData_1.getSupplyTimeseries)(),
                (0, fetchData_1.getSupplyMetrics)(),
                (0, fetchData_1.getFoundationHolding)(),
                (0, fetchData_1.getBurnedSupplyTimeseries)(),
                (0, fetchData_1.getTokenDistribution)(),
            ]);
            const [balanceListResult, supplyResult, supplyMetricsResult, foundationHoldingResult, burnedSupplyResult, tokenDistributionResult,] = await Promise.all(result);
            const { tokenSupplyFeed, payload } = supplyResult;
            setBalanceList(balanceListResult);
            setSupplyMetrics(supplyMetricsResult);
            // console.log(tokenSupplyFeed);
            setTokenSupply(tokenSupplyFeed);
            setTokenSupplyPayload(payload);
            setBurnedTokens(burnedSupplyResult);
            setFoundationHolding(foundationHoldingResult);
            setTokenDistribution(tokenDistributionResult);
            setIsPageLoading(false);
        }
        catch (e) {
            console.log(e);
        }
    };
    (0, react_1.useEffect)(() => {
        getData();
    }, []);
    (0, react_1.useEffect)(() => { }, [tokenSupplyPayload]);
    return (react_2.default.createElement(origyn_art_ui_1.Container, { padding: '48px', mdPadding: '24px' },
        react_2.default.createElement(HelmetTitle_1.default, { title: 'OGY Dashboard', description: 'OGY Dashboard Homepage' }),
        react_2.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 24 },
            react_2.default.createElement(origyn_art_ui_1.Grid, { columns: 2, gap: 24 },
                react_2.default.createElement(origyn_art_ui_1.Card, { padding: "24px", style: { background: "linear-gradient(270.34deg, #293170 0%, #313272 6%, #473577 14%, #6A3A7F 25%, #793C82 29%, #803483 44%, #852E83 66%, #59132A 97%, #551022 100%)" } },
                    react_2.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 16 },
                        react_2.default.createElement("h2", { style: { color: "#fff" } }, "New To OGY?"),
                        react_2.default.createElement("p", { style: { color: "#fff" } }, "OGY is the native utility token of the ORIGYN platform \u2014 used to create digital certificates, mint NFTs and more!"),
                        react_2.default.createElement("div", null,
                            react_2.default.createElement(origyn_art_ui_1.Button, { style: { background: "#e8e6e6", color: '#000' }, as: "a", target: "_blank", href: "https://origyn.gitbook.io/origyn/tokenomics/tokenomics-3.0", btnType: "filled" }, "Learn More About OGY")))),
                react_2.default.createElement(origyn_art_ui_1.Card, { padding: "24px", style: { background: "linear-gradient(90.34deg, #1F9CD4 3%, #1470B1 30%, #1A5EA2 36%, #214B92 44%, #254088 53%, #263C85 63%, #25397E 69%, #223169 79%, #1E2448 90%, #1E2345 91%)" } },
                    react_2.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 16 },
                        react_2.default.createElement("h2", { style: { color: "#fff" } }, "Earn Rewards By Staking"),
                        react_2.default.createElement("p", { style: { color: "#fff" } }, "Token holders will stake their OGY tokens to participate in governance and earn rewards for voting."),
                        react_2.default.createElement("div", null,
                            react_2.default.createElement(origyn_art_ui_1.Button, { style: { background: "#e8e6e6", color: '#000' }, as: "a", target: "_blank", href: "https://origyn.gitbook.io/origyn/tokenomics/staking-and-rewards", btnType: "filled" }, "Learn More About Staking")))))),
        react_2.default.createElement(styled_components_1.ThemeProvider, { theme: isDarktheme ? themes_1.darkTheme : themes_1.lightTheme },
            react_2.default.createElement(Section_1.default, { isLoading: isLoading, sectioncol: { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 } },
                react_2.default.createElement(TotalSupplyCards_1.default, { assets: foundationHolding, data: supplyMetrics ? supplyMetrics[0] : undefined, isPageLoading: isLoading })),
            react_2.default.createElement(Section_1.default, { isLoading: isLoading, sectioncol: { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 } },
                react_2.default.createElement(NesteDataCardContainer, null,
                    react_2.default.createElement(BurnedTokens_1.default, { isPageLoading: isLoading, data: supplyMetrics ? supplyMetrics[1] : undefined }),
                    react_2.default.createElement(FOC_1.default, { isPageLoading: isLoading, data: supplyMetrics ? supplyMetrics[2] : undefined }))),
            react_2.default.createElement(Section_1.default, { isLoading: isLoading, sectioncol: { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }, title: "Governance rewards for staked tokens" },
                react_2.default.createElement(exports.SliderCard, { start: { xs: 1, sm: 1, md: 2, lg: 3, xl: 3 }, end: { xs: 13, sm: 13, md: 12, lg: 11, xl: 11 } },
                    react_2.default.createElement(react_2.default.Fragment, null,
                        react_2.default.createElement(Overview_1.DataCardLabel, null, "Reward Rate"),
                        react_2.default.createElement(slider_1.default, { col: 12, isPageLoading: isLoading, color: "onBg" })))),
            react_2.default.createElement(Section_1.default, { isLoading: isLoading, title: "General Data" },
                react_2.default.createElement(CustomLineChart_1.default, { tooltipPayload: tokenSupplyPayload, stacked: true, chartTitle: "Supply", yAxisUnit: "B OGY", data: tokenSupply, isPageLoading: isLoading, yAxisdivider: format_1.b })),
            react_2.default.createElement(Section_1.default, { isLoading: isLoading },
                react_2.default.createElement(CustomLineChart_1.default, { tooltipPayload: burnedTokens?.map(({ date, burnedFees }) => ({ date, burnedFees })), stacked: true, chartTitle: "Burned Fees", yAxisUnit: "OGY", data: burnedTokens?.map(({ date, burnedFees }) => ({ date, burnedFees })), isPageLoading: isLoading })),
            react_2.default.createElement(Section_1.default, { isLoading: isLoading },
                react_2.default.createElement(CustomLineChart_1.default, { tooltipPayload: burnedTokens?.map(({ date, burnedTokens }) => ({ date, burnedTokens })), stacked: true, chartTitle: "Burned Donations", yAxisUnit: "M OGY", data: burnedTokens?.map(({ date, burnedTokens }) => ({ date, burnedTokens })), isPageLoading: isLoading, yAxisdivider: format_1.m })),
            react_2.default.createElement(Section_1.default, { isLoading: isLoading, title: "Token distribution" },
                react_2.default.createElement(SimpleTable_1.default, { colWidth: {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }, isPageLoading: isLoading, initData: balanceList, tooltips: {
                        "Canister Account Id": "AccountIDs are asset-specific unique identifiers of canisters on the Internet Computer and represent the balance in the ICP ledger. The list bellows includes amongst other the ORIGYN Governance Canister as well as the AccoundIDs of the wallet of individual OGY holders"
                    }, dataFetching: (n, r) => (0, fetchData_1.getBalanceListByPage)(n, r) })))));
}
exports.default = OgyDashboard;
exports.SliderCard = (0, styled_components_1.default)(material_1.Box) `
  padding: ${(props) => props.theme.spacing?.margin?.xl} ${(props) => props.theme.spacing.margin.lg};
  background-color: ${(props) => props.theme.colors.altBg};
  color: ${(props) => props.theme.colors.onAltBg};
  border-radius: 20px;
  grid-column-start: ${(props) => props?.start?.xl};
  grid-column-end: ${(props) => props?.end?.xl};
  ${(props) => props.theme.media.lg} {
    grid-column-start: ${(props) => props.start?.lg};
    grid-column-end: ${(props) => props.end?.lg};
  }
  ${(props) => props.theme.media.md} {
    grid-column-start: ${(props) => props.start.md};
    grid-column-end: ${(props) => props.end.md};
  }
  ${(props) => props.theme.media.sm} {
    grid-column-start: ${(props) => props.start.sm};
    grid-column-end: ${(props) => props.end.sm};
  }
  ${(props) => props.theme.media.xs} {
    grid-column-start: ${(props) => props.start.xs};
    grid-column-end: ${(props) => props.end.xs};
  }
`;
const NesteDataCardContainer = (0, styled_components_1.default)('div') `
  column-gap: 15px;
  row-gap: 0;
  display: grid;
  grid-column: span 12;
  background-image: ${(props) => props.theme.colors.gradientBg};
  grid-template-columns: repeat(12, 1fr);
  padding: ${(props) => props.theme.spacing.margin.md};
  border-radius: 30px;
  ${(props) => props.theme.media.lg} {
    padding: ${(props) => props.theme.spacing.margin.md};
    grid-column: span 12;
  }
  ${(props) => props.theme.media.md} {
    padding: ${(props) => props.theme.spacing.margin.md};
    grid-column: span 12;
    row-gap: 15px;
  }
  ${(props) => props.theme.media.sm} {
    padding: ${(props) => props.theme.spacing.margin.sm};
    grid-column: span 12;
  }
  ${(props) => props.theme.media.xs} {
    padding: ${(props) => props.theme.spacing.margin.xs};
    grid-column: span 12;
  }
`;
const Text = (0, styled_components_1.default)(material_1.Box) `
  color: ${(props) => props.theme.colors.onBg};
  grid-column: span 9;
  font-size: 1em;
  padding: 15px 0;
  line-height: 1.4em;
  ${(props) => props.theme.media.lg} {
    grid-column: span 9;
  }
  ${(props) => props.theme.media.md} {
    grid-column: span 9;
  }
  ${(props) => props.theme.media.sm} {
    grid-column: span 12;
  }
  ${(props) => props.theme.media.xs} {
    grid-column: span 12;
  }
`;
